'use client';

import { FC } from 'react';

import { ElementProps } from '@ravago/shared/page-data/models/base';
import { NormalizedCaseStudy } from '@ravago/shared/page-data/models/contentful-mapped';
import { CaseStudyWarningBadgeNode } from '@ravago/shared/page-data/models/elements';
import { Alert } from '@ravago/shared/radiance/components/alert/components/Alert/Alert';
import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

export const CaseStudyWarningBadgeElement: FC<ElementProps<CaseStudyWarningBadgeNode>> = ({ node, globals }) => {
   const translate = useTranslations();
   const { contentEntity, isConsumer } = globals;
   const caseStudy = contentEntity as NormalizedCaseStudy;

   if (!caseStudy) {
      if (isConsumer) return null;

      return <Alert variant="info">No case study found.</Alert>;
   }

   const isInternal = caseStudy.visibility === 'Internal' || false;
   const { confidential } = caseStudy;

   if (!isInternal && !confidential) {
      if (isConsumer) return null;

      return (
         <Typography component="p" variant="body" color="secondary">
            No badge will be displayed, Case study is not internal and not confidential.
         </Typography>
      );
   }

   return (
      <Badge variant={node.variant} size={node.size}>
         {confidential ? translate('case-study-confidential') : translate('case-study-internal-only')}
      </Badge>
   );
};
